import api from "./api";
import { AutorDTO, BuchDTO, ExemplarDTO } from "../types/buchTypes";

export const buchApi = {
  createBuch: async (buch: BuchDTO) => {
    const res = await api.post("/admin/bucherstellen", buch);
    return res.data;
  },

  updateBuch: async (id: number, dto: BuchDTO) => {
    const res = await api.put(`/admin/buch/${id}`, dto);
    return res.data;
  },

  deleteBuch: async (id: number) => {
    const res = await api.delete(`/admin/buch/${id}`);
    return res.data;
  },

  getBuchById: async (id: number) => {
    const res = await api.get(`/admin/buch/${id}`);
    return res.data as BuchDTO;
  },

  getAllBuecher: async () => {
    const res = await api.get(`/admin/allbooks`);
    return res.data as BuchDTO[];
  },

  getAllAutors: async () => {
    const res = await api.get(`/admin/allautors`);
    return res.data as AutorDTO[];
  },

  createAutor: async (autor: AutorDTO, buchId?: number) => {
    // Optional kann der Autor direkt einem Buch zugeordnet werden
    const url = buchId ? `/admin/buch/${buchId}/autor` : `/admin/autor`;
    const res = await api.post(url, autor);
    return res.data as AutorDTO;
  },

  deleteAutorFromBuch: async (buchId: number, autorId: number) => {
    const res = await api.delete(`/admin/buch/${buchId}/autor/${autorId}`);
    return res.data;
  },

  // --- Buch-Autor Beziehung direkt updaten (falls Backend-Endpoint vorhanden) ---
  updateBuchAutor: async (buchId: number, autorId: number) => {
    const res = await api.post(`/admin/buch/${buchId}/autor/${autorId}`);
    return res.data;
  },

  addExemplar: async (id: number, exemplar: ExemplarDTO) => {
    const res = await api.post(`/admin/buch/${id}/exemplar`, exemplar);
    return res.data as ExemplarDTO;
  },

  deleteExemplar: async (id: number, exemplar: ExemplarDTO) => {
    const res = await api.post(`/admin/buch/${id}/deleteexemplar`, exemplar);
    return res.data;
  },
};
